(() => {
  const COFFEES = [
    { handle:"brazil-cerrado", name:"Brazil Cerrado", tags:["forgiving","chocolatey","drip-friendly"] },
    { handle:"ethiopia-yirgacheffe", name:"Ethiopia Yirgacheffe", tags:["bright","filter-friendly"] },
    { handle:"desert-nectar", name:"Desert Nectar", tags:["balanced","forgiving"] }
  ];

  const root = document.getElementById("abuelaQuiz");
  if (!root) return;

  let step = 0;
  let stage = "quiz";

  const answers = {
    taste: 30,
    strength: 50
  };

  function wrap(content, pct){
    return `
      <div class="abuela-card abuela-fade">
        <div class="abuela-progress">
          <span>Step ${step+1} of 3</span>
          <div class="abuela-bar"><div style="width:${pct}%"></div></div>
        </div>
        ${content}
      </div>
    `;
  }

  function tasteLabel(v){
    if (v < 33) return "Sour / sharp";
    if (v > 66) return "Bitter / harsh";
    return "Balanced";
  }

  function strengthLabel(v){
    if (v < 33) return "Weak";
    if (v > 66) return "Strong";
    return "Just right";
  }

  function render(){
    if (stage === "quiz") {
      if (step === 0) {
        root.innerHTML = wrap(`
          <div class="abuela-slider">
            <div class="abuela-slider-top">
              <strong>How does it taste?</strong>
              <span class="abuela-pill">${tasteLabel(answers.taste)}</span>
            </div>
            <input class="abuela-range" type="range" min="0" max="100" value="${answers.taste}" id="taste">
            <div class="abuela-zones">
              <div class="abuela-zone ${answers.taste<33?"on":""}">Sour</div>
              <div class="abuela-zone ${answers.taste>=33&&answers.taste<=66?"on":""}">Balanced</div>
              <div class="abuela-zone ${answers.taste>66?"on":""}">Bitter</div>
            </div>
          </div>
          <div class="abuela-footer">
            <button class="abuela-btn" id="next">Next</button>
          </div>
        `,33);

        document.getElementById("taste").oninput = e => {
          answers.taste = +e.target.value;
          render();
        };
        document.getElementById("next").onclick = ()=>{ step++; render(); };
        return;
      }

      if (step === 1) {
        root.innerHTML = wrap(`
          <div class="abuela-slider">
            <div class="abuela-slider-top">
              <strong>How strong is it?</strong>
              <span class="abuela-pill">${strengthLabel(answers.strength)}</span>
            </div>
            <input class="abuela-range" type="range" min="0" max="100" value="${answers.strength}" id="strength">
            <div class="abuela-zones">
              <div class="abuela-zone ${answers.strength<33?"on":""}">Weak</div>
              <div class="abuela-zone ${answers.strength>=33&&answers.strength<=66?"on":""}">Just right</div>
              <div class="abuela-zone ${answers.strength>66?"on":""}">Strong</div>
            </div>
          </div>
          <div class="abuela-footer">
            <button class="abuela-secondary" id="back">Back</button>
            <button class="abuela-btn" id="next">Next</button>
          </div>
        `,66);

        document.getElementById("strength").oninput = e => {
          answers.strength = +e.target.value;
          render();
        };
        document.getElementById("back").onclick = ()=>{ step--; render(); };
        document.getElementById("next").onclick = ()=>{ stage="results"; render(); };
        return;
      }
    }

    if (stage === "results") {
      const picks = COFFEES.slice(0,2);
      root.innerHTML = `
        <div class="abuela-card abuela-fade">
          <strong>Abuela says:</strong>
          <p>
            ${answers.taste<33?"It needs more time.":answers.taste>66?"It stayed too long.":"The taste is close."}
            ${answers.strength<33?" Add a little more coffee.":answers.strength>66?" Use a little less.":""}
          </p>

          <div class="abuela-cards">
            ${picks.map(p=>`
              <div class="abuela-prod">
                <div class="abuela-prod-img" style="background-image:url('/products/${p.handle}.jpg')"></div>
                <div class="abuela-prod-body">
                  <div class="abuela-prod-name">${p.name}</div>
                  <a class="abuela-prod-link" href="/products/${p.handle}">View coffee</a>
                </div>
              </div>
            `).join("")}
          </div>

          <div class="abuela-footer">
            <button class="abuela-secondary" onclick="location.reload()">Start over</button>
          </div>
        </div>
      `;
    }
  }

  render();
})();
